import { map, isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Section from 'components/Section'
import Loader from 'components/Loader'
import ReportingCategoryForm from 'components/ReportingCategories/Form'
import ReportingCategoryItem from 'components/ReportingCategories/ReportingCategoryItem'

import {
  getMajorCategories,
  isLoadingCategories,
} from 'store/Categories/selectors'
import {
  getIsItemsLoading,
  getItemsGroupedByReportingCategoryUuid,
} from 'store/Items/selector'

const ReportingCategoriesList = () => {
  const reportingCategories = useSelector(getMajorCategories)
  const isCategoriesLoading = useSelector(isLoadingCategories)
  const isItemsLoading = useSelector(getIsItemsLoading)

  const itemsGroupedByReportingCategoryUuid = useSelector(
    getItemsGroupedByReportingCategoryUuid
  )

  const { state: urlQueryParamsState } = useLocation()

  const isModal = !isEmpty(urlQueryParamsState?.reportingCategoryUuid)
  // we won't show loader on the list when modal is open
  const isLoading =
    (isCategoriesLoading || isItemsLoading) && !isModal
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Section className="item-list">
        {map(reportingCategories, ({ name, uuid }) => (
          <ReportingCategoryItem
            name={name}
            uuid={uuid}
            key={uuid}
            assignedItemsLength={
              itemsGroupedByReportingCategoryUuid?.[uuid]?.length ?? 0
            }
          />
        ))}
      </Section>
      {isModal && <ReportingCategoryForm />}
    </>
  )
}

export default ReportingCategoriesList
